import { render, staticRenderFns } from "./MalSearchOption.vue?vue&type=template&id=2abbc2a8&scoped=true"
import script from "./MalSearchOption.vue?vue&type=script&lang=ts"
export * from "./MalSearchOption.vue?vue&type=script&lang=ts"
import style0 from "./MalSearchOption.vue?vue&type=style&index=0&id=2abbc2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abbc2a8",
  null
  
)

export default component.exports